export const SignupPaths = {
  trialSignup: '/trial-signup',
  trialSignup2: '/trial-signup/2',
  trialSignup3: '/trial-signup/3',
};
